import { DayPicker } from "react-day-picker";
import { AssortGroup } from "../../../models/AssortGroup";
import "../../../../style/calendar.scss";
import "../../../../style/block.scss";
import "./style.scss";
import useLocaleByLanguage from "../../../../utils/hooks/useLocaleByLanguage";
import { useTranslation } from "react-i18next";
import { addDays, format } from "date-fns";
import EADivider from "../../shared/EADivider";
import { useEffect, useState } from "react";
import EAModal from "../../shared/Modal/EAModal";
import EAButton from "../../shared/Buttons/EAButton";

interface IProps {
  item: AssortGroup;
  selectedDate: Date;
  setDateBetween: (date: Date) => void;
  ids: string;
}

const CalendarPassMobile: React.FC<IProps> = ({ item, selectedDate, setDateBetween, ids }) => {
  const locale = useLocaleByLanguage();
  const { t } = useTranslation();
  const isDiscount = item.price !== item.listPrice;
  const [, setDateRange] = useState<{ toDate: Date } | null>(null);
  const [open, setOpen] = useState(false);
  const [clicked, setClicked] = useState(false);

  useEffect(() => {
    const today = new Date();
    const futureDate = new Date();
    if (ids === "1243" || ids === "1241") {
      futureDate.setDate(today.getDate() + 31);
      setDateRange({ toDate: futureDate });
    } else {
      futureDate.setDate(today.getDate() + 90);
      setDateRange({ toDate: futureDate });
    }
    //eslint-disable-next-line
  }, []);

  return (
    <div className="calendar-pass">
      <div className="calendar-pass-calendar">
        <div className="calendar-pass-date__choose">
          Wybierz datę rozpoczęcia
          {clicked ? (
            <EAButton title={format(selectedDate, "dd.MM.yyyy")} onClick={() => setOpen(true)} variant="outlined" />
          ) : (
            <EAButton title="Wybierz" onClick={() => setOpen(true)} />
          )}
        </div>
      </div>

      <EADivider />

      <div className="calendar-pass-details">
        <div className="flex-between-center">
          <span className="text-color-dark">{t("waznosc")}:</span>
          <b>
            {format(selectedDate, "dd.MM.yyyy")} - {format(addDays(selectedDate, item.dayValidate), "dd.MM.yyyy")}
          </b>
        </div>
        <div className="flex-between-center">
          <span className="text-color-dark">{t("wartosc_karnetu")}:</span>
          <div style={{ display: "flex", alignItems: "flex-end", gap: 4 }}>
            <b className={`price ${isDiscount ? "price-through" : ""}`}>
              {item.listPrice.toFixed(2)} {t("zl")}
            </b>
            {isDiscount && (
              <b className={`price ${isDiscount ? "price-through-color" : ""}`}>
                {item.price.toFixed(2)} {t("zl")}
              </b>
            )}
          </div>
        </div>
      </div>

      <EAModal isOpen={open} onClose={() => setOpen(false)} hideButtons title={t("wybierz_date")}>
        <div className="eamodal__calendar">
          <DayPicker
            mode="single"
            locale={locale}
            selected={selectedDate}
            fromDate={new Date()}
            onSelect={(date) => {
              setDateBetween(date ?? new Date());
              setOpen(false);
              setClicked(true);
            }}
            showOutsideDays
            modifiersClassNames={{
              selected: "my-selected",
              today: "my-today",
              range: "pass-range",
            }}
            modifiers={{ range: { from: selectedDate, to: addDays(selectedDate, item.dayValidate) } }}
          />
        </div>
      </EAModal>
    </div>
  );
};

export default CalendarPassMobile;
